import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  calculateTotalLeaveDay,
  formReqLeaveLongTermUpdate,
  formReqLeaveUpdate,
  updateTotalLeaveDay,
} from "../redux/formReqLeave";
import { TypeSelect } from "../redux/formReqArrivingLateLeaveEarly";

import moment from "moment";

import { listApprover } from "../components/CustomCalendarTimeKeeping/const";
import { toast } from "react-toastify";
import { ErrorMessage } from "core/http/service/decleareLeave/const";
import { getEmployeeLeaveDetailByIdApi } from "core/http/service/employeeRequest";
import {
  getEmployeeLeaveDetailStart,
  getEmployeeLeaveDetailFailed,
  getEmployeeLeaveDetailSuccess,
} from "../redux/getEmployeeLeaveDetail";
import { getRequestLeaveDetailSuccess } from "../redux/getRequestLeaveDetail";

function* getEmployeeRequestLeaveDetailWork(action) {
  const { id } = action.payload || {};
  try {
    const res = yield call(getEmployeeLeaveDetailByIdApi, id);
    const totalLeaveDay = calculateTotalLeaveDay(res?.details);
    yield put({
      type: updateTotalLeaveDay.type,
      payload: totalLeaveDay,
    });
    let listApproverCode = {};
    res?.approvals.forEach((item, index) => {
      listApproverCode = {
        ...listApproverCode,
        [listApprover[index]]: item.approverCode,
      };
    });
    const payloadForm = {
      id: res?.id,
      type: res?.type,
      relatedPersonCodes:
        res?.relatedPersons?.map((it) => ({
          label: `${it?.label} - ${it?.positionName}`,
          value: it?.value || it?.employeeCode,
        })) || [],
      note: res?.leaveReason,
      leaveManagers: res?.leaveManagers || [],
      approvals: (res?.approvals || [])?.map((item: any) => ({
        ...item,
        name: item?.approverName,
        value: item?.approverCode,
        label: `${item?.approverName} - ${item?.positionName || ""}`,
      })),
      files: res?.attachedFiles || [],
      numberChildren: res?.numberChildren ? String(res?.numberChildren) : null,
      ...listApproverCode,
    };
    const formLongTerm =
      res?.type === TypeSelect.SHORT_TERM
        ? {}
        : {
            fromDate: moment(res?.details[0]!?.fromDate),
            toDate: moment(res?.details[res?.details?.length - 1]!?.toDate),
            hexColor: res?.details[0]!?.hexColor,
            reasonName: res?.details[0]!?.reasonName,
            reasonCode: res?.details[0]!?.reasonCode,
            leaveReasonTypeName: res?.details[0]!?.leaveReasonTypeName,
            type: res?.details[0]!?.type,
            requireAttachFiles: res?.details[0]!?.requireAttachFiles || false,
            leaveReasonType: res?.details[0]!?.leaveReasonType,
            countWeekends: res?.details[0]!?.countWeekends,
            countHolidays: res?.details[0]!?.countHolidays,
            leaveReasonTypeMap: res?.details[0]!?.leaveReasonTypeMap || {},
            specificType: res?.details[0]!?.specificType || "",
            maxDayForFeMale: res?.details[0]!?.maxDayForFeMale || 0,
            minDayForFeMale: res?.details[0]!?.minDayForFeMale || 0,
            rangeDateUnitForFeMale:
              res?.details[0]!?.rangeDateUnitForFeMale || "",
          };
    yield put({
      type: getEmployeeLeaveDetailSuccess.type,
      payload: res,
    });
    yield put({
      type: getRequestLeaveDetailSuccess.type,
      payload: res,
    });
    yield put({
      type: formReqLeaveUpdate.type,
      payload: payloadForm,
    });
    yield put({
      type: formReqLeaveLongTermUpdate.type,
      payload: formLongTerm,
    });
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: getEmployeeLeaveDetailFailed.type,
      payload: ErrorMessage[error?.response?.data?.code] ?? "Có lỗi xảy ra",
    });
  }
}

function* watchGetEmployeeRequestLeaveDetail() {
  yield takeLatest(
    getEmployeeLeaveDetailStart.type,
    getEmployeeRequestLeaveDetailWork
  );
}

export default function* getEmployeeRequestLeaveDetailSaga() {
  yield all([watchGetEmployeeRequestLeaveDetail()]);
}
